import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import '../../styles/sections.css';
import '../../styles/appshowcase.css';

const AppShowcase = () => {
  return (
          <section className="appshowcase-section">
        <div className="section-header">
          <h2>APP SHOWCASE</h2>
          <div className="underline"></div>
        </div>
        <div className="appshowcase-content">
        <p style={{ textAlign: 'center', marginBottom: '2rem', color: '#ccc' }}>
          Screenshots coming soon
        </p>
      </div>
    </section>
  );
};

export default AppShowcase;

